import { HeroSearchInput } from './HeroSearchInput';

export function HeroSearchForm() {
  return (
    <div className="flex w-11/12 items-center justify-between gap-x-3 rounded-md border bg-white/[40%] px-2 py-3 md:w-3/4">
      <HeroSearchInput />
    </div>
  );
}
